/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-controls-volume-down': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M15.688 6.662l-.95.838a3.75 3.75 0 01-.113 4.963l.919.85a5 5 0 00.143-6.62v-.03zM12.5 18.75a.625.625 0 01-.444-.188L7.294 13.75H3.125a.625.625 0 01-.625-.625v-6.25c0-.345.28-.625.625-.625h4.169l4.762-4.813a.625.625 0 01.882 0 .625.625 0 01.187.438v16.25c0 .345-.28.625-.625.625zM3.75 12.5H7.5a.731.731 0 01.494.188l3.881 3.918V3.394L7.994 7.312A.731.731 0 017.5 7.5H3.75v5z"/>'
  }
})
